import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Components
import Toast from "components/WMS/Toast";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";

// Helpers
import {getTranslation} from "domain/helpers/translations";

EndPickingRetailerToast.propTypes = {
    wmsItem: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
};

function EndPickingRetailerToast({wmsItem, isOpen, handleClose}) {
    if (!wmsItem || !wmsItem.lineItem || !wmsItem.lineItem.retailer) {
        return null;
    }

    const [retailer] = useState(wmsItem.lineItem.retailer);

    return (
        <Toast
            icon={(<ThumbnailAndNotification link={getTranslation(retailer)?.logo?.contentUrl || ""} />)}
            title={(
                <FormattedMessage
                    id={'wms.myPickingMissions.retailer.end.toast.title'}
                    values={{retailerName: retailer.name}}
                />
            )}
            open={isOpen}
            handleClose={handleClose}
        />
    );
}

export default EndPickingRetailerToast;
